module.exports = __webpack_public_path__ + "media/images/diy/reservation_bg-288cda6edce0fb520db5054ed2e03da2.png";